import React, { useEffect } from "react";
import { DashboardBupati } from "../../componen/kepaladinas/DashboardBupati";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMeAdmin } from "../../fitur/AuthSlice";

export const DashboardBupatiPages = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isError } = useSelector((state) => state.authAdmin);
  
    useEffect(() => {
      dispatch(getMeAdmin());
    }, [dispatch]);
  
    useEffect(() => {
      if (isError) {
        navigate("/");
      }
    }, [isError, navigate]);
  return (
    <>
   <DashboardBupati />

   {/* <Footer /> */}
   </>
  )
}
